import type { Asset } from '../types'
import seeds from './mockSeeds.json'

/**
 * Generated demo library.
 *
 * The images in public/demo/ are generated packaging illustrations: each one is
 * drawn from that asset's own tags, so a "can" looks like a can and a "pouch"
 * looks like a pouch. They are stand-ins for the real visual audit, not
 * photography.
 *
 * This set only shows when library/ is empty — it exists so a fresh checkout
 * does not look broken. Drop real images into library/ and it steps aside.
 * See src/shared/services/localLibrary.ts.
 */

interface Seed {
  id: string
  title: string
  /** Tag id of the source frame */
  frame: string
  /** Category / structure / material / finish / style tags */
  tags: string[]
  /** Original dimensions */
  w: number
  h: number
}

const MIRO_BOARD_IDS = ['uXjVNxxxxAudit01=', 'uXjVNxxxxInspo02=', 'uXjVNxxxxShelf03=']

/** Produce a hash-looking string. Mock only — this is not a real hash. */
function fakeHash(prefix: string, index: number, length: number): string {
  let out = ''
  let n = (index + 1) * 2654435761
  while (out.length < length) {
    n = (n * 1103515245 + 12345) >>> 0
    out += n.toString(16)
  }
  return prefix + out.slice(0, length)
}

function pad(n: number): string {
  return String(n).padStart(2, '0')
}

export const MOCK_ASSETS: Asset[] = (seeds as Seed[]).map((seed, i) => {
  const day = ((i * 7) % 27) + 1
  const month = ((i * 3) % 12) + 1

  return {
    id: seed.id,
    title: seed.title,
    originalPath: `/demo/${seed.id}.png`,
    thumbnailPath: `/demo/${seed.id}.png`,
    source: 'miro',
    miroBoardId: MIRO_BOARD_IDS[i % MIRO_BOARD_IDS.length],
    sourceFrame: seed.frame,
    fileHash: fakeHash('sha256:', i, 24),
    perceptualHash: fakeHash('p:', i + 97, 16),
    width: seed.w,
    height: seed.h,
    mimeType: 'image/png',
    tagIds: [...seed.tags, seed.frame],
    aiDescription: `${seed.title}. Packaging reference captured from the ${seed.frame
      .replace('frame-', '')
      .replace(/-/g, ' ')} frame.`,
    createdAt: `2025-${pad(month)}-${pad(day)}T09:00:00.000Z`,
  } satisfies Asset
})
